import React, { Component } from "react";
import { trackPromise } from "react-promise-tracker";
import Popup from "react-popup";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import history from "../../login/history";
import ConfigService from "../../../../services/configuracion/ConfigService";
import Loader from 'react-loader-spinner';
import PinVirtualService from '../../../../services/autogestion/pinVirtualService';
export default class Paso2 extends Component {

  constructor(props) {
    super(props);
    this.getInitialState = this.getInitialState.bind(this);
    this.state = this.getInitialState();
    // this.receiveMessageFromIframe = this.receiveMessageFromIframe.bind(this);
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            // action : this.returnHome()
            action: function () {
              Popup.close();
              history.push(ConfigService.getPathByName("resumenGeneralSocio").url);
              window.location.reload();
            },
          },
        ],
      },
    });

  returnHome = (e) =>{
    history.push(ConfigService.getPathByName("resumenGeneralSocio").url);
    window.location.reload();
  }

  getInitialState = () => ({
    buscando:false,
    parametro:undefined,
    url:'https://pinpad.infonet.com.py:4444/vpinpad/#'
  });

  resetState = () => {
    this.setState(this.getInitialState());
  };

  componentDidMount() {
    this.initData();
    if(sessionStorage.getItem('PASO2') === 'true' && sessionStorage.getItem('ACTION') === 'MODIFICAR' && !sessionStorage.getItem('PASO3') ){
      this.validarPinIngresado();
      this.obtenerToken();
    }
    // window.addEventListener('message',this.receiveMessageFromIframe);
  }

  // componentWillUnmount(){
  //   window.removeEventListener('message',this.receiveMessageFromIframe);
  // }

  initData = () => {
    this.getInitialState();
  };    

  validarPinIngresado(){
    let data = {
      pan : sessionStorage.getItem('numeroTC'),
      tokenPinpad: sessionStorage.getItem('PARAMETRO')
    }
    trackPromise(
      PinVirtualService.validarPinIngresado(data)
      .then( response => {
        if( response.data.datos === null ){
          this.setState({buscando:false});
          Popup.queue(this.notifiPopup("Error", response.data.mensaje));
        }
        if( response.data.datos.success === 'false' ){
          Popup.queue(this.notifiPopup('Error: ',response.data.datos.message));
        }
        this.setState({buscando:false});
      })
      .catch( err =>{
        Popup.queue(this.notifiPopup('Error: ','Error al consultar estado del PIN'));
        return;
      })
    )
  }

  obtenerToken(){
    this.setState({buscando:true});
    let data = {
      pan : sessionStorage.getItem('numeroTC')
    }
    trackPromise(
      PinVirtualService.obtenerToken(data)
      .then( response =>{
        if( response.data.datos === null ){
          this.setState({buscando:false});
          Popup.queue(this.notifiPopup("Error", response.data.mensaje));
        }
        if( response.data.datos.success === 'true' ){
          this.setState({url:this.state.url + response.data.datos.token , buscando : false});
        }else{
          this.setState({buscando:false});
          Popup.queue(this.notifiPopup("Error", 'No se pudo obtener el tokenPinpad'));
        }
      })
      .catch( err => {
        this.setState({buscando:false});
        Popup.queue(this.notifiPopup("Error", err));
      })
    );
  }

  render() {

    if( this.state.buscando ){
      return (<Loader type="TailSpin" color="#007c34" height="100" width="100" />);
    }

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
              {
                sessionStorage.getItem('ACTION') === 'CREAR' ?
                (
                  <ul role="tablist">
                    <li role="tab" className="disabled">
                      <span>
                        <div className="title">                
                          <span className="title_text">Nuevo Pin</span>
                        </div>
                      </span>
                    </li>

                    <li role="tab" className="current last">
                      <span>
                        <div className="title">
                          <span className="title_text">Confirmación</span>
                        </div>
                      </span>
                    </li>
                  </ul>
                )
                :
                (
                    <ul role="tablist">
                      <li role="tab" className="disabled">
                        <span>
                          <div className="title">                
                            <span className="title_text">Pin Actual</span>
                          </div>
                        </span>
                      </li>

                      <li role="tab" className="current">
                        <span>
                          <div className="title">
                            <span className="title_text">Nuevo Pin</span>
                          </div>
                        </span>
                      </li>

                      <li role="tab" className="disabled last">
                        <span>
                          <div className="title">
                            <span className="title_text">Confirmación</span>
                          </div>
                        </span>
                      </li>
                    </ul>
                )
              }
          </div>
        </div>
        <section className="content">
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <h4 style={{color: '#1A9185', margin:"1rem"}}>Ingresar el PIN Nuevo</h4>
              <div className="callout callout-warning consideraciones" style={{lineHeight:"1.8rem"}}>
                <h5>Consideraciones</h5>
                <p>Recuerde que su PIN es exclusivamente para su uso personal y que sustituye a su firma, siendo de su entera responsabilidad el uso del mismo. No lo divulgue ni lo escriba. No elija un PIN que sea fácil de deducir por terceros (ej. año nacimiento). La Universitaria Ltda. se exime de toda responsabilidad y/o reclamo que pudiera surgir eventualmente por las operaciones realizadas a través de su PIN.</p>
              </div>
            </div>
            <div className="col-md-12 d-flex my-2 justify-content-center">
              <div class='pinpad' onChange={this.onClickPinpad}>
                <iframe title="PinPad" frameBorder='0'
                  width='332.5px'
                  height='338.55px'
                  src={this.state.url}>
                </iframe>
              </div>
            </div>
          </div>
        </section>

        <hr/>  
        
        <div className="row">
        
        <div className="col-md-12 btn-consulta">
          <button 
            className="btn btn-cu-secundary" 
            onClick={this.returnHome}
          >
              <FontAwesomeIcon icon={faArrowLeft} /> Volver al Inicio
          </button>
        </div>  
        </div>
      </div>
    );
  }
}
